export * from './lib/shared-ui-svg.module';
